<template>
  <el-dialog
    class="teacher-dialog"
    :title="isEdit ? '机构编辑' : '机构新增'"
    :visible.sync="dialogVisible"
    width="50%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    @close="handleClose">
    <!-- 表单 -->
    <div class="form-container">
      <el-form ref="ruleForm" :model="form" label-width="100px" :inline="true">
        <el-form-item
          v-for="(item,i) in form.fieldList"
          :key="i"
          :label="item.fieldName"
          :prop="'fieldList.' + i + '.value'"
          :rules="{
            required: item.isRequire === 1 ? true : false, message: item.fieldName + '不能为空', trigger: 'blur'
          }">
          <el-input
            v-model="item.value"
            :placeholder="'请输入' + item.fieldName"
            :disabled="item.type === 1"
            maxLength="200">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit('ruleForm', false)">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getContent } from '@/api/api'
export default {
  components: {
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        fieldList: [{
          value: ''
        }]
      },
      isEdit: false,
      id: ''
    }
  },
  methods: {
    init(data) {
      this.form.fieldList = JSON.parse(JSON.stringify(data.fieldList));
      if (data.form) {
        this.isEdit = true;
        this.id = data.form.id;
        this.$set(this.form.fieldList[0], 'value', data.form.name)
        this.$set(this.form.fieldList[1], 'value', data.form.shortName)
        getContent({
          organizationId: data.form.id
        }).then(res => {
          let { code, data } = res;
          if (code === 0) {
            this.form.fieldList.forEach(item => {
              data.forEach(list => {
                if (item.fieldName === list.fieldName) {
                  this.$set(item, 'value', list.fieldValue);
                }
              })
            })
          }
        })
        return
      } else {
        this.id = '';
      }
    },
    // 关闭弹窗
    handleClose() {
      this.$emit('close');
    },
    // 提交表单/是否预览
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        let formArr = [];
        this.form.fieldList.forEach(item => {
          formArr.push({
            fieldId: item.id,
            name: item.fieldName,
            value: item.value,
            sortNum: item.sortNum,
            isShow: item.isShow
          });
        })
        let form = {
          id: this.id ? this.id : '',
          name: this.form.fieldList[0].value,
          shortName: this.form.fieldList[1].value,
          jsonStr: JSON.stringify(formArr)
        }
        if (valid) {
          this.$emit('submit', form);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
  .teacher-dialog {
    ::v-deep .el-dialog {
      .el-dialog__header {
        // background-color: #909399;
        padding: 10px;
        .el-dialog__title {
          font-size: 15px;
          // color: #fff;
        }
        .el-dialog__headerbtn {
          top: 10px;
          i {
            // color: #fff;
          }
        }
      }
      .el-dialog__body {
        max-height: 500px;
        overflow-y: scroll;
      }
      .el-form {
        .el-form-item {
          margin-bottom: 25px;
          .el-form-item__error {
            margin: 5px 0;
          }
          .el-form-item__label {
            font-size: 12px;
          }
          .el-input {
            width: 200px;
          }
        }
      }
      .el-dialog__footer {
        width: 100%;
        border-top: 1px solid #ddd;
        padding-top: 15px;
      }
    }
  }
</style>